import {Box, Button} from '@mui/material'
import {Edit} from 'iconsax-reactjs'
import {useTranslation} from 'react-i18next'

interface CreateNewChatButtonProps {
  onClick: () => void
}

const CreateNewChatButton = ({onClick}: CreateNewChatButtonProps) => {
  const [t] = useTranslation()
  return (
    <Box paddingX={2} display="flex" justifyContent="center">
      <Button
        endIcon={<Edit size={24} />}
        variant="contained"
        size="small"
        color="primary"
        sx={() => ({
          justifyContent: 'flex-start',
          marginTop: 2,
          borderRadius: 3
        })}
        onClick={onClick}
      >
        {t('fnd-assistant-button-new-chat-session')}
      </Button>
    </Box>
  )
}

export default CreateNewChatButton
